module.exports = __webpack_public_path__ + "img/white.be1b721.svg";